import { Box } from "@mui/material";
import { GridRowModesModel } from "@mui/x-data-grid";
import { useState, useCallback } from "react";

import ChangeStatus from "src/components/status-log/ChangeStatus";
import { ITask } from "src/interface/ITask";
import { useDashboardData } from "src/context/dashboard-data";
import SkeltonProgress from "src/components/SkeltonProgress";
import GridViewMUIX from "src/components/GridViewMUIX";
import { useColumns } from "./columns";
import NewUser from "src/pages/users/new-user";

interface TaskProps {
  rows: ITask[];
  refetch: () => void;
  isLoading: boolean;
}
const Tasks = ({ isLoading, refetch, rows }: TaskProps) => {
  const [openChangeTask, setOpenChangeTask] = useState(false);
  const [rowInfo, setRowInfo] = useState<ITask>();
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});
  const [openEditUser, setOpenEditUser] = useState<boolean>(false);
  const [selectedUserId, setSelectedUserId] = useState<string>();

  // ==================== استفاده از Context ====================
  const { customersOptions: getCustomers, editorsOptions: getEditors } =
    useDashboardData();

  const handleEditStatusClick = useCallback(
    (row: ITask) => () => {
      setOpenChangeTask(true);
      setRowInfo(row);
    },
    []
  );

  const handleTaskChangeClose = useCallback(() => setOpenChangeTask(false), []);

  const handleEditUserClose = useCallback(() => {
    setOpenEditUser(false);
    setSelectedUserId(undefined);
  }, []);

  const columns = useColumns({
    handleEditStatusClick,
    getCustomers,
    getEditors,
    handleEditUserClick: (userId: string) => {
      setSelectedUserId(userId);
      setOpenEditUser(true);
    },
  });

  return (
    <>
      <ChangeStatus
        open={openChangeTask}
        handleClose={handleTaskChangeClose}
        refetch={refetch}
        Taskdata={rowInfo as ITask}
      />
      <NewUser
        open={openEditUser}
        setOpenBank={handleEditUserClose}
        refetch={refetch}
        isEdit={true}
        userRef={selectedUserId}
        userRole="Customer"
        setUserId={setSelectedUserId}
        usersData={[]}
        tags={[]}
      />
      <Box
        sx={{
          width: {
            xs: 370,
            sm: 500,
            md: 720,
            lg: "calc(100% - 80px)",
            xl: "calc(100% - 80px)",
          },
        }}
      >
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            columns={columns}
            loading={isLoading}
            rowModesModel={rowModesModel}
            sortFields={{ field: "modifiedOn", sort: "desc" }}
            rows={rows}
            setRowModesModel={setRowModesModel}
            gridUniqueName="TasksDashboard1"
          />
        )}
      </Box>
    </>
  );
};

export default Tasks;
